import { observer } from "mobx-react";

import CreateModal from "@component/CreateModal";
import Dependent from "@model/Dependent";
import DependentCreateVM from "@vm/Create/Dependent";
import Form from "./Form";

import { lazyInject, TYPES } from "../../../inversify.config";

@observer
export default class DependentCreateModal extends CreateModal<Dependent> {
  modelName = "dependent";
  prefix = "employee";

  @lazyInject(TYPES.DependentCreate)
  vm: DependentCreateVM;

  componentDidMount(): void {
    this.vm.setParentId(this.props.match.params.user_id);
    super.componentDidMount();
  }

  onClose = () => {
    this.router.pageLink(this.uriHelper.employees_dependents(this.props.match.params.user_id));
  };

  renderModalBody() {
    return <Form entity={this.vm.entity} hasCurrentHPPContract={this.vm.hasCurrentHPPContract} />;
  }
}
